import React from "react";
import { AlertTriangle, XCircle, AlertCircle, CheckCircle2 } from "lucide-react";
import { Card, Badge } from "../GraderUI";
import { getSeverityClass } from "../gradeColors";

const SEVERITY_CONFIG = {
	critical: {
		icon: XCircle,
		modifier: "critical",
	},
	high: {
		icon: AlertTriangle,
		modifier: "high",
	},
	medium: {
		icon: AlertCircle,
		modifier: "medium",
	},
	low: {
		icon: AlertCircle,
		modifier: "low",
	},
};

export default function IndexabilityWarning({ data }) {
	if (!data || data.severity === "none" || data.all_indexable) {
		return (
			<Card className="indexability-warning indexability-warning--success">
				<div className="indexability-warning__success-row">
					<CheckCircle2 className="indexability-warning__success-icon" />
					<div>
						<h4 className="indexability-warning__success-title">All Pages Indexable</h4>
						<p className="indexability-warning__success-text">
							No NOINDEX directives found - site is fully accessible to AI and search engines
						</p>
					</div>
				</div>
			</Card>
		);
	}

	const config = SEVERITY_CONFIG[data.severity] || SEVERITY_CONFIG.medium;
	const Icon = config.icon;

	return (
		<Card className={`indexability-warning indexability-warning--${config.modifier}`}>
			<div className="indexability-warning__header">
				<Icon className="indexability-warning__header-icon" />
				<div className="indexability-warning__header-body">
					<div className="indexability-warning__title-row">
						<h3 className="indexability-warning__title">Indexability Issues Detected</h3>
						<Badge className={`indexability-warning__severity ${getSeverityClass(data.severity)}`}>
							{data.severity.toUpperCase()}
						</Badge>
					</div>
					<p className="indexability-warning__summary">
						{data.noindex_count} of {data.total_pages} pages have NOINDEX directives (
						{data.noindex_percentage}%)
					</p>
				</div>
			</div>

			<div className="indexability-warning__issues">
				{data.issues.map((issue, idx) => (
					<div key={idx} className="indexability-warning__issue">
						<span className="indexability-warning__issue-bullet">•</span>
						<span>{issue}</span>
					</div>
				))}
			</div>

			{data.recommendations.length > 0 && (
				<div className="indexability-warning__recommendations">
					<h4 className="indexability-warning__recommendations-title">Recommended Actions:</h4>
					<ul className="indexability-warning__recommendations-list">
						{data.recommendations.map((rec, idx) => (
							<li key={idx} className="indexability-warning__recommendation">
								<span className="indexability-warning__recommendation-arrow">→</span>
								<span>{rec}</span>
							</li>
						))}
					</ul>
				</div>
			)}

			{data.severity === "critical" && data.noindex_pages.length > 0 && (
				<div className="indexability-warning__pages">
					<h4 className="indexability-warning__pages-title">Blocked Pages:</h4>
					<div className="indexability-warning__pages-list">
						{data.noindex_pages.slice(0, 5).map((page, idx) => (
							<div key={idx} className="indexability-warning__page-url">
								{page.url}
							</div>
						))}
						{data.noindex_pages.length > 5 && (
							<div className="indexability-warning__pages-more">
								...and {data.noindex_pages.length - 5} more pages
							</div>
						)}
					</div>
				</div>
			)}
		</Card>
	);
}
